(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/core/svs-socket/assets/javascripts/socket.js') >= 0) return;  svs.modules.push('/components/core/svs-socket/assets/javascripts/socket.js');
"use strict";

var _svs$core$config, _svsConfig$tpns;
function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _classPrivateFieldSet(s, a, r) { return s.set(_assertClassBrand(s, a), r), r; }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }


const MAXIMUM_ATTEMPTS = 5;
const logger = svs.core.log.getLogger('svs.core.svs-socket');

const svsConfig = (_svs$core$config = svs.core.config) === null || _svs$core$config === void 0 || (_svs$core$config = _svs$core$config.data) === null || _svs$core$config === void 0 ? void 0 : _svs$core$config.svsconfig;
const localBaseUri = "".concat(window.location.origin, "/api");
const isPullRequestEnvironment = svsConfig === null || svsConfig === void 0 || (_svsConfig$tpns = svsConfig.tpns) === null || _svsConfig$tpns === void 0 ? void 0 : _svsConfig$tpns.includes('_mr');
let svsFetchBaseUri = localBaseUri;
if (isPullRequestEnvironment) {
  svsFetchBaseUri = localBaseUri;
} else if (svsConfig !== null && svsConfig !== void 0 && svsConfig.svsFetchBaseUri) {
  svsFetchBaseUri = svsConfig.svsFetchBaseUri;
}
var _socket = new WeakMap();
var _microservice = new WeakMap();
var _subscribers = new WeakMap();
var _activeSubscriptions = new WeakMap();
var _transportType = new WeakMap();
var _socketId = new WeakMap();
var _hasEverConnected = new WeakMap();
var _lastResubscribeSocketId = new WeakMap();
var _SVSSocket_brand = new WeakSet();
var _isConnected = new WeakMap();
class SVSSocket {
  constructor(_microservice2, _baseUrl) {
    _classPrivateMethodInitSpec(this, _SVSSocket_brand);
    _classPrivateFieldInitSpec(this, _socket, undefined);
    _classPrivateFieldInitSpec(this, _microservice, undefined);
    _classPrivateFieldInitSpec(this, _subscribers, new Set());
    _classPrivateFieldInitSpec(this, _activeSubscriptions, new Map());
    _classPrivateFieldInitSpec(this, _transportType, null);
    _classPrivateFieldInitSpec(this, _socketId, null);
    _classPrivateFieldInitSpec(this, _hasEverConnected, false);
    _classPrivateFieldInitSpec(this, _lastResubscribeSocketId, null);
    _classPrivateFieldInitSpec(this, _isConnected, () => _classPrivateFieldGet(_socket, this).connected || _classPrivateFieldGet(_socket, this).active);
    _classPrivateFieldSet(_microservice, this, _microservice2);
    _assertClassBrand(_SVSSocket_brand, this, _initSocket).call(this, _microservice2, _baseUrl);
  }
  subscribe(endpoint, onSocketData) {
    let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    if (!endpoint) {
      throw new Error('svs.core.svsSocket.subscribe requires endpoint.');
    }
    if (typeof onSocketData !== 'function') {
      throw new Error('svs.core.svsSocket.subscribe requires callback.');
    }
    const needsInitialUpdate = options.sendInitialUpdate === true;
    const existingSubscriber = _assertClassBrand(_SVSSocket_brand, this, _findSubscriber).call(this, endpoint, onSocketData);
    if (existingSubscriber) {
      if (needsInitialUpdate) {
        existingSubscriber.needsInitialUpdate = true;
        _assertClassBrand(_SVSSocket_brand, this, _syncEndpointSubscription).call(this, endpoint);
      }
      return {
        unsubscribe: () => {
          _assertClassBrand(_SVSSocket_brand, this, _removeSubscriber).call(this, existingSubscriber);
        }
      };
    }
    const subscriber = {
      endpoint,
      onSocketData,
      needsInitialUpdate
    };
    _assertClassBrand(_SVSSocket_brand, this, _addSubscriber).call(this, subscriber);
    return {
      unsubscribe: () => {
        _assertClassBrand(_SVSSocket_brand, this, _removeSubscriber).call(this, subscriber);
      }
    };
  }
}
function _findSubscriber(endpoint, onSocketData) {
  for (const subscriber of _classPrivateFieldGet(_subscribers, this)) {
    if (subscriber.endpoint === endpoint && subscriber.onSocketData === onSocketData) {
      return subscriber;
    }
  }
  return null;
}
function _getSubscribersByEndpoint(endpoint) {
  return [..._classPrivateFieldGet(_subscribers, this)].filter(subscriber => subscriber.endpoint === endpoint);
}
function _syncEndpointSubscription(endpoint) {
  const endpointSubscribers = _assertClassBrand(_SVSSocket_brand, this, _getSubscribersByEndpoint).call(this, endpoint);
  const existingSubscription = _classPrivateFieldGet(_activeSubscriptions, this).get(endpoint);
  if (!endpointSubscribers.length) {
    if (existingSubscription) {
      _classPrivateFieldGet(_socket, this).emit('unsubscribe', {
        path: existingSubscription.endpoint
      });
      _classPrivateFieldGet(_activeSubscriptions, this).delete(endpoint);
    }
    return;
  }
  const shouldRequestInitialUpdate = endpointSubscribers.some(subscriber => subscriber.needsInitialUpdate);
  const shouldEmitSubscribe = !existingSubscription || shouldRequestInitialUpdate && !existingSubscription.waitingForInitialUpdate;
  if (!shouldEmitSubscribe) {
    return;
  }
  _classPrivateFieldGet(_socket, this).emit('subscribe', {
    path: endpoint,
    sendInitialUpdate: shouldRequestInitialUpdate
  });
  _classPrivateFieldGet(_activeSubscriptions, this).set(endpoint, {
    endpoint,
    waitingForInitialUpdate: shouldRequestInitialUpdate
  });
}
function _resubscribeActiveSubscriptions() {
  if (!_classPrivateFieldGet(_activeSubscriptions, this).size || _classPrivateFieldGet(_lastResubscribeSocketId, this) === _classPrivateFieldGet(_socket, this).id) {
    return;
  }
  _classPrivateFieldSet(_lastResubscribeSocketId, this, _classPrivateFieldGet(_socket, this).id);
  for (const [endpoint, endpointSubscription] of _classPrivateFieldGet(_activeSubscriptions, this)) {
    const endpointSubscribers = _assertClassBrand(_SVSSocket_brand, this, _getSubscribersByEndpoint).call(this, endpoint);
    const shouldRequestInitialUpdate = endpointSubscription.waitingForInitialUpdate || endpointSubscribers.some(subscriber => subscriber.needsInitialUpdate);
    _classPrivateFieldGet(_socket, this).emit('subscribe', {
      path: endpoint,
      sendInitialUpdate: shouldRequestInitialUpdate
    });
    endpointSubscription.waitingForInitialUpdate = shouldRequestInitialUpdate;
  }
}
function _sendSocketDataToSubscriber(subscriber, socketData) {
  try {
    subscriber.onSocketData(socketData);
  } catch (error) {
    const errorLog = error !== null && error !== void 0 && error.message ? error.message : error;
    logger.error('Error in socket subscriber callback: ', errorLog, {
      metadata: {
        socket: _classPrivateFieldGet(_socketId, this),
        transType: _classPrivateFieldGet(_transportType, this),
        path: subscriber.endpoint
      }
    });
  }
}
function _onSocketDataUpdate(socketData) {
  const updatePath = socketData === null || socketData === void 0 ? void 0 : socketData.path;
  if (!updatePath) {
    return;
  }
  const endpointSubscription = _classPrivateFieldGet(_activeSubscriptions, this).get(updatePath);

  if (endpointSubscription !== null && endpointSubscription !== void 0 && endpointSubscription.waitingForInitialUpdate) {
    try {
      for (const subscriber of _classPrivateFieldGet(_subscribers, this)) {
        if (subscriber.endpoint === updatePath && subscriber.needsInitialUpdate) {
          _assertClassBrand(_SVSSocket_brand, this, _sendSocketDataToSubscriber).call(this, subscriber, socketData);
          subscriber.needsInitialUpdate = false;
        }
      }
    } finally {
      endpointSubscription.waitingForInitialUpdate = false;
    }
    return;
  }

  for (const subscriber of _classPrivateFieldGet(_subscribers, this)) {
    if (subscriber.endpoint && subscriber.endpoint === updatePath) {
      _assertClassBrand(_SVSSocket_brand, this, _sendSocketDataToSubscriber).call(this, subscriber, socketData);
    }
  }
}
function _initSocket(microservice, baseUrl) {
  const socketUrl = new URL(baseUrl);
  _classPrivateFieldSet(_socket, this, io(socketUrl.origin, {
    autoConnect: false,
    path: "".concat(socketUrl.pathname).concat(microservice),
    transports: ['websocket', 'polling'],
    reconnectionAttempts: MAXIMUM_ATTEMPTS
  }));
  _classPrivateFieldGet(_socket, this).on('connect', () => {
    const wasEverConnected = _classPrivateFieldGet(_hasEverConnected, this);
    const engine = _classPrivateFieldGet(_socket, this).io.engine;
    _classPrivateFieldSet(_transportType, this, engine.transport.name);
    _classPrivateFieldSet(_socketId, this, _classPrivateFieldGet(_socket, this).id);
    _classPrivateFieldSet(_hasEverConnected, this, true);
    logger.info('Connected', {
      metadata: {
        socket: _classPrivateFieldGet(_socketId, this),
        transType: _classPrivateFieldGet(_transportType, this)
      }
    });
    if (wasEverConnected) {
      _assertClassBrand(_SVSSocket_brand, this, _resubscribeActiveSubscriptions).call(this);
    }
  });
  _classPrivateFieldGet(_socket, this).io.on('error', error => {
    logger.warn('Socket error', error, {
      metadata: {
        socket: _classPrivateFieldGet(_socketId, this),
        transType: _classPrivateFieldGet(_transportType, this)
      }
    });
  });
  _classPrivateFieldGet(_socket, this).io.on('reconnect', attemptNumber => {
    logger.info('Reconnect', {
      metadata: {
        socket: _classPrivateFieldGet(_socketId, this),
        transType: _classPrivateFieldGet(_transportType, this),
        attempt: attemptNumber
      }
    });
    _assertClassBrand(_SVSSocket_brand, this, _resubscribeActiveSubscriptions).call(this);
  });
  _classPrivateFieldGet(_socket, this).io.on('reconnect_attempt', attemptNumber => {
    logger.debug('Reconnect attempt', {
      metadata: {
        socket: _classPrivateFieldGet(_socketId, this),
        transType: _classPrivateFieldGet(_transportType, this),
        attempt: attemptNumber
      }
    });
    if (attemptNumber >= MAXIMUM_ATTEMPTS) {
      var _classPrivateFieldGet2;
      const errorMsg = "Closing socket after ".concat(attemptNumber, " reconnection attempts.");
      if ((_classPrivateFieldGet2 = _classPrivateFieldGet(_socket, this)) !== null && _classPrivateFieldGet2 !== void 0 && _classPrivateFieldGet2.close) {
        logger.warn(errorMsg);
        _classPrivateFieldGet(_socket, this).close();
      }
    }
  });
  _classPrivateFieldGet(_socket, this).io.on('reconnect_error', error => {
    logger.debug('Reconnect error', error, {
      metadata: {
        socket: _classPrivateFieldGet(_socketId, this),
        transType: _classPrivateFieldGet(_transportType, this)
      }
    });
  });
  _classPrivateFieldGet(_socket, this).io.on('reconnect_failed', () => {
    logger.info('Reconnect failed', {
      metadata: {
        socket: _classPrivateFieldGet(_socketId, this),
        transType: _classPrivateFieldGet(_transportType, this)
      }
    });
  });
  _classPrivateFieldGet(_socket, this).on('connect_error', error => {
    const engine = _classPrivateFieldGet(_socket, this).io.engine;
    _classPrivateFieldSet(_transportType, this, engine.transport.name);

    if (_classPrivateFieldGet(_socket, this).active) {
      logger.info('Connect error: socket will try to reconnect', error, {
        metadata: {
          socket: _classPrivateFieldGet(_socketId, this),
          transType: _classPrivateFieldGet(_transportType, this)
        }
      });
      return;
    }
    logger.error('Connect error: socket is dead', error, {
      metadata: {
        socket: _classPrivateFieldGet(_socketId, this),
        transType: _classPrivateFieldGet(_transportType, this)
      }
    });
  });
  _classPrivateFieldGet(_socket, this).on('disconnect', reason => {
    _classPrivateFieldSet(_lastResubscribeSocketId, this, null);
    logger.info('Disconnect', {
      metadata: {
        socket: _classPrivateFieldGet(_socketId, this),
        transType: _classPrivateFieldGet(_transportType, this),
        reason
      }
    });
  });
  _classPrivateFieldGet(_socket, this).on('update', socketData => {
    try {
      _assertClassBrand(_SVSSocket_brand, this, _onSocketDataUpdate).call(this, socketData);
    } catch (error) {
      const errorLog = error !== null && error !== void 0 && error.message ? error.message : error;
      logger.error('Error in socket update handler: ', errorLog);
    }
  });

  window.addEventListener('beforeunload', () => {
    if (_classPrivateFieldGet(_isConnected, this).call(this)) {
      _classPrivateFieldGet(_socket, this).off();
      _classPrivateFieldGet(_socket, this).disconnect();
    }
  }, {
    once: true
  });
}
function _connectSocket() {
  _classPrivateFieldGet(_socket, this).connect();
}
function _disconnectSocket() {
  _classPrivateFieldGet(_socket, this).disconnect();
}
function _addSubscriber(subscriber) {
  if (_classPrivateFieldGet(_subscribers, this).size === 0) {
    _assertClassBrand(_SVSSocket_brand, this, _connectSocket).call(this);
  }
  _classPrivateFieldGet(_subscribers, this).add(subscriber);
  _assertClassBrand(_SVSSocket_brand, this, _syncEndpointSubscription).call(this, subscriber.endpoint);
}
function _removeSubscriber(subscriber) {
  _classPrivateFieldGet(_subscribers, this).delete(subscriber);
  _assertClassBrand(_SVSSocket_brand, this, _syncEndpointSubscription).call(this, subscriber.endpoint);
  if (_classPrivateFieldGet(_subscribers, this).size === 0) {
    _assertClassBrand(_SVSSocket_brand, this, _disconnectSocket).call(this);
  }
}
const microservices = new Map();

const get = function (microservice) {
  let baseUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : svsFetchBaseUri;
  if (!microservice.startsWith('/')) {
    throw new Error('svs.core.svsSocket.get requires microservice to start with "/".');
  }
  if (baseUrl.endsWith('/')) {
    throw new Error('svs.core.svsSocket.get requires baseUrl not to end with "/".');
  }
  if (baseUrl.length === 0) {
    return; 
  }
  const msKey = "".concat(microservice, "-").concat(baseUrl);
  if (microservices.has(msKey)) {
    return microservices.get(msKey);
  }
  const newMicroservice = new SVSSocket(microservice, baseUrl);
  microservices.set(msKey, newMicroservice);
  return newMicroservice;
};
svs.core.svsSocket.get = get;

 })(window);